export const novelOpenings: Record<string, string[]> = {
  en: [
    'It was the best of times, it was the worst of times, it was the age of wisdom, it was the age of foolishness...',
    'Call me Ishmael.',
    'It is a truth universally acknowledged, that a single man in possession of a good fortune, must be in want of a wife.',
    'Happy families are all alike; every unhappy family is unhappy in its own way.',
    'In a hole in the ground there lived a hobbit.',
    'It was a bright cold day in April, and the clocks were striking thirteen.',
    'The sun shone, having no alternative, on the nothing new.',
    'The past is a foreign country; they do things differently there.',
    'Lolita, light of my life, fire of my loins.',
    'All happy families are alike; each unhappy family is unhappy in its own way.',
  ],
  es: [
    'En un lugar de la Mancha, de cuyo nombre no quiero acordarme, no ha mucho tiempo que vivía un hidalgo de los de lanza en astillero, adarga antigua, rocín flaco y galgo corredor.',
    'Muchos años después, frente al pelotón de fusilamiento, el coronel Aureliano Buendía había de recordar aquella tarde remota en que su padre lo llevó a conocer el hielo.',
    'Era el mejor de los tiempos, era el peor de los tiempos, la edad de la sabiduría, y también de la locura...',
    'Cuando Gregorio Samsa se despertó una mañana después de un sueño intranquilo, se encontró sobre su cama convertido en un monstruoso insecto.',
    'En el principio era el Verbo, y el Verbo era con Dios, y el Verbo era Dios.',
    'Yo no tengo la culpa de haber nacido tan guapo.',
    'El día en que lo iban a matar, Santiago Nasar se levantó a las 5.30 de la mañana para esperar el buque en que llegaba el obispo.',
    'Era una tarde de verano, calurosa y silenciosa, y los hombres estaban sentados en la terraza del café.',
    'A principios del siglo XX, cuando yo era niño, no había en España más que dos clases de hombres: los que trabajaban y los que no trabajaban.',
    'El hombre que se llamaba a sí mismo el Conde de Montecristo entró en el salón de los dos jóvenes.',
  ],
  fr: [
    'Longtemps, je me suis couché de bonne heure.',
    'Aujourd\'hui, maman est morte. Ou peut-être hier, je ne sais pas.',
    'Il était une fois un roi et une reine qui avaient tant d\'enfants qu\'ils ne savaient plus quoi en faire.',
    'Je suis né dans une famille de paysans, dans un petit village de la Beauce.',
    'L\'homme naît libre, et partout il est dans les fers.',
    'C\'était à Mégara, faubourg de Carthage, dans les jardins d\'Hamilcar.',
    'Le soleil se levait à peine derrière les collines de la Savoie.',
    'Il y avait une fois un roi qui avait une fille si belle qu\'on ne pouvait la regarder sans l\'aimer.',
    'Je vais vous raconter une histoire qui m\'a été contée par un vieux marin.',
    'Dans une province éloignée, au fond d\'un vallon, s\'élevait un château dont les tours pointues se dressaient fièrement vers le ciel.',
  ],
  de: [
    'Es war einmal ein König, der hatte eine Tochter, die war so schön, dass die Sonne selbst sich wunderte.',
    'Als Gregor Samsa eines Morgens aus unruhigen Träumen erwachte, fand er sich in seinem Bett zu einem ungeheueren Ungeziefer verwandelt.',
    'Es ist eine allgemein anerkannte Wahrheit, dass ein alleinstehender Mann, der im Besitz eines schönen Vermögens ist, eine Frau braucht.',
    'Alles, was ich über das Leben weiß, habe ich von den Hunden gelernt.',
    'Es war die beste Zeit, es war die schlechteste Zeit, es war das Zeitalter der Weisheit, es war das Zeitalter der Torheit...',
    'In einem Loch im Boden, da lebte ein Hobbit.',
    'Der Mensch ist frei geboren und liegt überall in Ketten.',
    'Es war einmal ein Mädchen, das hatte keine Angst.',
    'Die Sonne schien, da sie keine Alternative hatte, auf nichts Neues.',
    'Ich bin ein Teil von jener Kraft, die stets das Böse will und stets das Gute schafft.',
  ],
  it: [
    'Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura, ché la diritta via era smarrita.',
    'Tutti i felici sono felici allo stesso modo, ogni famiglia infelice è infelice a modo suo.',
    'Chiamatemi Ismaele.',
    'Era il migliore dei tempi, era il peggiore dei tempi, l\'età della saggezza, l\'età della follia...',
    'In un buco nel terreno viveva uno hobbit.',
    'Il sole splendeva, non avendo alternative, su nulla di nuovo.',
    'La mamma è morta oggi. O forse ieri, non so.',
    'Tutto ciò che so della vita l\'ho imparato dai cani.',
    'Era una notte buia e tempestosa.',
    'Nel principio era il Verbo, e il Verbo era presso Dio, e il Verbo era Dio.',
  ],
  pt: [
    'Muitos anos depois, diante do pelotão de fuzilamento, o coronel Aureliano Buendía havia de recordar aquela tarde remota em que seu pai o levou para conhecer o gelo.',
    'Era o melhor dos tempos, era o pior dos tempos, a idade da sabedoria, a idade da loucura...',
    'Chamem-me Ismael.',
    'Todas as famílias felizes são iguais; cada família infeliz é infeliz à sua maneira.',
    'Em um buraco no chão vivia um hobbit.',
    'O sol brilhava, não tendo alternativa, sobre nada de novo.',
    'Tudo o que sei sobre a vida aprendi com os cães.',
    'Era uma vez um rei que tinha uma filha tão bonita que o próprio sol se maravilhava.',
    'No princípio era o Verbo, e o Verbo estava com Deus, e o Verbo era Deus.',
    'A mãe morreu hoje. Ou talvez ontem, não sei.',
  ],
  ca: [
    'El Joe em va agafar de la mà i vaig passar tot el dia pensant en el ball.',
    'Mentre caminava, anava pensant en tot el que havia passat, i em semblava que el món s\'havia fet petit i estrany.',
    'Aquesta és la història d\'un home que es va perdre i, en perdre\'s, es va trobar.',
    'Quan vaig tornar al poble, després de tants anys, les cases em van semblar més baixes i els carrers més estrets.',
    'La Mila va arribar a l\'ermita cap al tard, quan els cingles ja es tenyien de violeta.',
    'Tirant lo Blanc, per la gran cavalleria i els alts fets d\'armes que féu, ha merescut eterna memòria.',
    'El meu pare deia sempre que les paraules són com les llavors: si cauen en bona terra, acaben donant fruit.',
    'Aquell estiu vaig entendre que la memòria no és un magatzem, sinó una manera de continuar vivint.',
    'La ciutat es despertava amb una llum groga, i jo caminava com si no hagués de tornar mai més.',
    'En el principi era el Verb, i el Verb era amb Déu, i el Verb era Déu.',
  ],
};

export const getRandomNovelOpening = (locale: string): string => {
  const languageCode = locale.split('-')[0].toLowerCase();
  const openings = novelOpenings[languageCode] || novelOpenings.en;
  const randomIndex = Math.floor(Math.random() * openings.length);
  return openings[randomIndex];
};
